import { TeamInviteStatus } from "./TeamInviteStatus";

export class TeamInvite {
    teamInviteId: string = "";
    teamId: string = "";
    dateInviteSent: Date = new Date();
    status: TeamInviteStatus = TeamInviteStatus.Pending;
    email: string = "";
    statusString: string = "";

    static getStatusString(status: number): string {
        console.log("checking this : " + typeof status);
        switch (status) {
            case 0: return "Pending";
            case 1: return "Accepted";
            case 2: return "Declined";
            default: return "Unknown";   
        }
    }
}
